var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import Input from '@shared/input/Input';
import { ArrowDown, ArrowRight, ArrowUp, ArrowUpDown, Copy, Delete, Edit, Forecast, Ladder, Lock, Unlock, Percentage, Plus, Refresh, Regression, Round, ThreeDots, Comment, } from '@shared/icons/icons';
import { ModelColumns } from '@util/enums';
import { isDimensionTagJsonData } from '@data/tag/types';
import { downloadFileViaBlob, farseerFilesApi } from '@data/rest/api';
import toast from 'react-hot-toast';
import Manager from '@shared/modal/Manager';
import EditTag from '@shared/finder/modals/EditTag';
import DeleteTagModal from '@shared/finder/modals/DeleteTag';
import { ThreeStateCheckBox } from '@shared/input/CheckBox';
var YEAR_TYPE = 12;
var handleKeyDown = function (e, type, handler, previous) {
    var inputValue = e.currentTarget.value;
    if (e.key === 'Enter' && inputValue !== '') {
        e.currentTarget.value = '';
        handler(type, { value: inputValue, previous: previous });
    }
};
export function getMenuConfig(handler, openNewListItemModal, canAddListItem, canAddComment, row, col, generated, editEnabled, L, versions, openCopyFromModal, fileInputRef, editTagJsonData, getLockValue, getVariableTopDownValue, navigate, currentUser) {
    var _this = this;
    var _a, _b, _c;
    var isDisabled = col && col.type === YEAR_TYPE.toString() ? col.type === YEAR_TYPE.toString() : false;
    var lockValue = getLockValue();
    var variableHasTopDown = getVariableTopDownValue();
    var addCommentMenuItem = {
        icon: Comment,
        actionName: L('Add Comment'),
        action: function () { return handler('add_comment'); },
        isDisabled: !canAddComment,
    };
    var lockUnlockMenuItem = {
        isDisabled: !editEnabled,
        Component: function (props) { return (React.createElement(ThreeStateCheckBox, __assign({}, props, { value: lockValue, action: function () { return handler('lock_selected'); }, label: L(L('Lock Row')), css: { width: '100%', paddingLeft: 10 }, labelStyle: { padding: '0px 8px' } }))); },
    };
    var sortMenuItem = {
        icon: ArrowUpDown,
        actionName: L('Sort'),
        isDisabled: !col,
        items: [
            {
                actionName: L('Ascending'),
                isDisabled: !col,
                items: versions.map(function (version) { return ({
                    actionName: version.name,
                    action: function () { return handler('sort', { asc: true, versionId: version.id, col: col }); },
                }); }),
            },
            {
                actionName: L('Descending'),
                isDisabled: !col,
                items: versions.map(function (version) { return ({
                    actionName: version.name,
                    action: function () { return handler('sort', { asc: false, versionId: version.id, col: col }); },
                }); }),
            },
            { spacer: true },
            {
                actionName: L('Unsort'),
                isDisabled: false,
                action: function () { return handler('sort', null); },
            },
        ],
    };
    var copyMenuItem = {
        icon: Copy,
        actionName: L('Copy'),
        isDisabled: !editEnabled,
        items: [
            {
                actionName: L('Left'),
                isDisabled: !editEnabled,
                items: [
                    {
                        actionName: L('12 Months'),
                        action: function () { return handler('12mnths', true); },
                        isDisabled: isDisabled,
                    },
                    {
                        actionName: L('Year Start'),
                        action: function () { return handler('year', true); },
                        isDisabled: isDisabled,
                    },
                    {
                        actionName: L('Timeline Start'),
                        action: function () { return handler('timeline', true); },
                    },
                    {
                        Component: function (props) { return (React.createElement(Input, __assign({}, props, { min: 1, type: "number", placeholder: L('Copy #'), onKeyDown: function (e) { return handleKeyDown(e, 'copy_for_periods', handler, true); } }))); },
                    },
                ],
            },
            {
                actionName: L('Right'),
                isDisabled: !editEnabled,
                items: [
                    {
                        actionName: L('12 Months'),
                        action: function () { return handler('12mnths', false); },
                        isDisabled: isDisabled,
                    },
                    {
                        actionName: L('Year End'),
                        action: function () { return handler('year', false); },
                        isDisabled: isDisabled,
                    },
                    {
                        actionName: L('Timeline End'),
                        action: function () { return handler('timeline', false); },
                    },
                    {
                        Component: function (props) { return (React.createElement(Input, __assign({}, props, { min: 1, type: "number", placeholder: L('Copy #'), onKeyDown: function (e) { return handleKeyDown(e, 'copy_for_periods', handler, false); } }))); },
                    },
                ],
            },
            { spacer: true },
            {
                actionName: L('From'),
                isDisabled: !editEnabled,
                items: [
                    {
                        actionName: L('Current Year'),
                        items: versions.map(function (version) { return ({
                            actionName: version.name,
                            action: function () { return handler('cells_copy', { tagIds: [version.versionTagId], offset: 0 }); },
                        }); }),
                    },
                    {
                        actionName: L('Previous Year'),
                        items: versions.map(function (version) { return ({
                            actionName: version.name,
                            action: function () { return handler('cells_copy', { tagIds: [version.versionTagId], offset: -12 }); },
                        }); }),
                    },
                    { spacer: true },
                    { actionName: L('Custom'), action: openCopyFromModal },
                ],
            },
        ],
    };
    var moreOptions = {
        icon: ThreeDots,
        actionName: L('More Options'),
        isDisabled: row ? false : true,
        items: [
            {
                icon: Lock,
                actionName: L('Lock Hierarchy'),
                isDisabled: !editEnabled,
                action: function () { return handler('lock_selected_hierarchies', { value: true }); },
                destructive: true,
            },
            {
                icon: Unlock,
                actionName: L('Unlock Hierarchy'),
                isDisabled: !editEnabled,
                action: function () { return handler('lock_selected_hierarchies', { value: false }); },
                destructive: true,
            },
        ],
    };
    var openInDatabaseEditor = !currentUser
        ? []
        : [
            {
                icon: ArrowRight,
                actionName: L('Open in Database Editor'),
                action: function () {
                    var _a, _b;
                    navigate("/database/".concat(((_a = generated.table) === null || _a === void 0 ? void 0 : _a.ParentId) || 0, "/").concat(((_b = generated.table) === null || _b === void 0 ? void 0 : _b.id) || 0));
                },
            },
        ];
    switch (col === null || col === void 0 ? void 0 : col.type) {
        case ModelColumns.TITLE:
            return (row === null || row === void 0 ? void 0 : row.generatedTagId) && generated.tag && generated.table
                ? __spreadArray(__spreadArray([
                    {
                        icon: Plus,
                        actionName: "".concat(L('New'), " ").concat(generated.table.name),
                        action: function () { var _a; return handler('add_tag', { tableId: (_a = generated.table) === null || _a === void 0 ? void 0 : _a.id, row: row }); },
                        creative: true,
                    },
                    { spacer: true },
                    {
                        icon: Edit,
                        actionName: "".concat(L('Edit'), " ").concat((_a = generated.tag) === null || _a === void 0 ? void 0 : _a.name),
                        action: function () {
                            if (generated.tag) {
                                Manager.renderModal(React.createElement(EditTag, { tag: generated.tag }));
                            }
                        },
                    }
                ], __read(openInDatabaseEditor), false), [
                    { spacer: true },
                    addCommentMenuItem,
                    lockUnlockMenuItem,
                    sortMenuItem,
                    { spacer: true },
                    moreOptions,
                    { spacer: true },
                    {
                        icon: Delete,
                        actionName: "".concat(L('Delete'), " ").concat((_b = generated.tag) === null || _b === void 0 ? void 0 : _b.name),
                        action: function () {
                            if (generated.tag) {
                                Manager.renderModal(React.createElement(DeleteTagModal, { deleteType: "tag", target: generated.tag }));
                            }
                        },
                        destructive: true,
                    },
                ], false) : row && generated.table // for 'No result' rows (it has generated table, but not generated tag)
                ? [
                    {
                        icon: Plus,
                        actionName: "".concat(L('New'), " ").concat((_c = generated.table) === null || _c === void 0 ? void 0 : _c.name),
                        action: function () { var _a; return handler('add_tag', { tableId: (_a = generated.table) === null || _a === void 0 ? void 0 : _a.id, row: row }); },
                        creative: true,
                    },
                    { spacer: true },
                    addCommentMenuItem,
                    lockUnlockMenuItem,
                    sortMenuItem,
                    { spacer: true },
                    moreOptions,
                ]
                : [addCommentMenuItem, lockUnlockMenuItem, sortMenuItem, { spacer: true }, moreOptions];
        case ModelColumns.DESCRIPTION:
        case ModelColumns.TAGS:
        case ModelColumns.MAPE:
        case ModelColumns.MASE:
        case ModelColumns.TEXT_PROPERTY:
        case ModelColumns.DATE_PROPERTY:
            return [addCommentMenuItem];
        case ModelColumns.FILE_PROPERTY:
            var propertyIdString_1 = col.dataString;
            if (!propertyIdString_1) {
                return [];
            }
            var tagJsonData_1 = generated.tag && generated.tag.jsonData ? generated.tag.jsonData : { values: {} };
            if (!isDimensionTagJsonData(tagJsonData_1)) {
                return [];
            }
            var existingValue_1 = tagJsonData_1.values[propertyIdString_1];
            if (!!existingValue_1 && typeof existingValue_1 === 'object') {
                var replaceFileHandler_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                    var inputElement, fileToUpload, farseerFile, newJsonData, err_1;
                    var _a;
                    var _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                inputElement = fileInputRef.current;
                                if (inputElement === null) {
                                    return [2 /*return*/];
                                }
                                fileToUpload = (_b = inputElement.files) === null || _b === void 0 ? void 0 : _b[0];
                                if (!(fileToUpload !== undefined)) return [3 /*break*/, 6];
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 5, , 6]);
                                if (!generated.tag) {
                                    return [2 /*return*/];
                                }
                                // remove old file
                                return [4 /*yield*/, farseerFilesApi.remove(existingValue_1.farseerFileId)];
                            case 2:
                                // remove old file
                                _c.sent();
                                return [4 /*yield*/, farseerFilesApi.create(fileToUpload, 'tag file')];
                            case 3:
                                farseerFile = _c.sent();
                                newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[propertyIdString_1] = { filename: farseerFile.name, farseerFileId: farseerFile.id }, _a)) });
                                return [4 /*yield*/, editTagJsonData(generated.tag.id, newJsonData)];
                            case 4:
                                _c.sent();
                                return [3 /*break*/, 6];
                            case 5:
                                err_1 = _c.sent();
                                toast.error(L('Error uploading file'));
                                return [3 /*break*/, 6];
                            case 6:
                                inputElement.removeEventListener('change', replaceFileHandler_1);
                                return [2 /*return*/];
                        }
                    });
                }); };
                return [
                    {
                        icon: Refresh,
                        actionName: L('Replace File'),
                        isDisabled: !editEnabled,
                        action: function () {
                            var inputElement = fileInputRef.current;
                            if (inputElement === null) {
                                return;
                            }
                            inputElement.addEventListener('change', replaceFileHandler_1);
                            inputElement.click();
                        },
                    },
                    {
                        icon: ArrowDown,
                        actionName: L('Download File'),
                        isDisabled: !editEnabled,
                        action: function () { return __awaiter(_this, void 0, void 0, function () {
                            var file;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, farseerFilesApi.get(existingValue_1.farseerFileId)];
                                    case 1:
                                        file = _a.sent();
                                        downloadFileViaBlob(file, existingValue_1.filename);
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    },
                    { spacer: true },
                    {
                        icon: Delete,
                        actionName: L('Delete File'),
                        isDisabled: !editEnabled,
                        destructive: true,
                        action: function () { return __awaiter(_this, void 0, void 0, function () {
                            var newJsonData, err_2;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 3, , 4]);
                                        if (!generated.tag) {
                                            return [2 /*return*/];
                                        }
                                        // remove old file
                                        return [4 /*yield*/, farseerFilesApi.remove(existingValue_1.farseerFileId)];
                                    case 1:
                                        // remove old file
                                        _b.sent();
                                        newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[propertyIdString_1] = null, _a)) });
                                        return [4 /*yield*/, editTagJsonData(generated.tag.id, newJsonData)];
                                    case 2:
                                        _b.sent();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        err_2 = _b.sent();
                                        toast.error(L('Error deleting file'));
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); },
                    },
                ];
            }
            else {
                var uploadFileHandler_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                    var inputElement, fileToUpload, farseerFile, newJsonData, err_3;
                    var _a;
                    var _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                inputElement = fileInputRef.current;
                                if (inputElement === null) {
                                    return [2 /*return*/];
                                }
                                fileToUpload = (_b = inputElement.files) === null || _b === void 0 ? void 0 : _b[0];
                                if (!(fileToUpload !== undefined)) return [3 /*break*/, 5];
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 4, , 5]);
                                if (!generated.tag) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, farseerFilesApi.create(fileToUpload, 'tag file')];
                            case 2:
                                farseerFile = _c.sent();
                                newJsonData = __assign(__assign({}, tagJsonData_1), { values: __assign(__assign({}, tagJsonData_1.values), (_a = {}, _a[propertyIdString_1] = { filename: farseerFile.name, farseerFileId: farseerFile.id }, _a)) });
                                return [4 /*yield*/, editTagJsonData(generated.tag.id, newJsonData)];
                            case 3:
                                _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                err_3 = _c.sent();
                                toast.error(L('Error uploading file'));
                                return [3 /*break*/, 5];
                            case 5:
                                inputElement.removeEventListener('change', uploadFileHandler_1);
                                return [2 /*return*/];
                        }
                    });
                }); };
                return [
                    {
                        icon: ArrowUp,
                        actionName: L('Upload File'),
                        isDisabled: !editEnabled,
                        action: function () {
                            var inputElement = fileInputRef.current;
                            if (inputElement === null) {
                                return;
                            }
                            inputElement.addEventListener('change', uploadFileHandler_1);
                            inputElement.click();
                        },
                    },
                ];
            }
        default: // MONTH, QUARTER, HALFYEAR, YEAR, YEAR_TO_DATE, SUM, COMPARISON, CUSTOM_COL, NUMBER_PROPERTY
            return [
                {
                    icon: Plus,
                    actionName: L('New List Item'),
                    action: openNewListItemModal,
                    isDisabled: !canAddListItem,
                    creative: true,
                },
                { spacer: true },
                {
                    icon: Round,
                    actionName: L('Round'),
                    isDisabled: !editEnabled,
                    action: function () { return handler('round'); },
                },
                {
                    icon: Regression,
                    actionName: L('Regression'),
                    isDisabled: !editEnabled,
                    action: function () { return handler('regression'); },
                },
                {
                    icon: Refresh,
                    actionName: L('Random'),
                    isDisabled: !editEnabled,
                    action: function () { return handler('random'); },
                },
                { spacer: true },
                {
                    icon: Forecast,
                    actionName: L('Forecast'),
                    isDisabled: !editEnabled,
                    items: __spreadArray(__spreadArray([
                        {
                            actionName: L('None'),
                            action: function () { return handler('forecast', { tagIds: [] }); },
                        }
                    ], __read(versions.map(function (version) { return ({
                        actionName: version.name,
                        action: function () { return handler('forecast', { tagIds: [version.versionTagId] }); },
                    }); })), false), [
                        { spacer: true },
                        { actionName: L('Custom...'), action: function () { return handler('forecast', 'custom'); } },
                    ], false),
                },
                copyMenuItem,
                { spacer: true },
                {
                    icon: Ladder,
                    actionName: '',
                    isDisabled: !editEnabled,
                    Component: function (props) { return (React.createElement(Input, __assign({}, props, { type: "number", placeholder: L('Set value'), onKeyDown: function (e) { return handleKeyDown(e, 'set_value', handler); } }))); },
                },
                {
                    icon: Percentage,
                    actionName: L('Apply Percentage'),
                    isDisabled: !editEnabled,
                    items: [
                        {
                            actionName: '5%',
                            action: function () { return handler('subadd_custom', { value: 5 }); },
                        },
                        {
                            actionName: '10%',
                            action: function () { return handler('subadd_custom', { value: 10 }); },
                        },
                        {
                            actionName: '-5%',
                            action: function () { return handler('subadd_custom', { value: -5 }); },
                        },
                        {
                            actionName: '-10%',
                            action: function () { return handler('subadd_custom', { value: -10 }); },
                        },
                        {
                            Component: function (props) { return (React.createElement(Input, __assign({}, props, { type: "number", placeholder: L('Apply %'), onKeyDown: function (e) { return handleKeyDown(e, 'subadd_custom', handler); } }))); },
                        },
                    ],
                },
                addCommentMenuItem,
                { spacer: true },
                sortMenuItem,
                {
                    icon: Lock,
                    actionName: L('Lock Top Down Cell'),
                    isDisabled: !editEnabled || !variableHasTopDown,
                    action: function () { return handler('lock_top_down_cell'); },
                },
            ];
    }
}
